import { CARRY_MODES, type WornSlot } from '@somnhold/content';
import { loadoutAt, type CampaignCommand, type HeroState, type ItemInstance } from '@somnhold/sim';
import { toastAction } from '../account.ts';
import { t } from '../i18n.ts';
import { itemName } from './gear-sheet.ts';

/**
 * A piece put on by hand while a preparation keeps another one in that slot (docs/DECISIONS.md 2026-11-04): that
 * preparation, and the spectre if it is the waves one, still goes in with the kept piece. Says so, with one touch to
 * keep the new piece there too. A player who picked a skill had its unique kept without noticing, put on another
 * one and saw the spectre keep fighting with the old.
 */
export const offerPin = (hero: HeroState, slot: WornSlot, item: ItemInstance, cmd: (c: CampaignCommand) => Promise<boolean>, rerender: () => void): void => {
  const stored = hero.loadouts ?? [];
  const pinned = stored.flatMap((l, i) => (l.gear?.[slot] !== undefined && l.gear[slot] !== item.id ? [i] : []));
  if (!pinned.length) return;
  const where = pinned
    .map((i) => {
      const modes = CARRY_MODES.filter((m) => (hero.carry?.[m] ?? 0) === i).map((m) => t(`carry.mode.${m}`));
      return stored[i]?.name || (modes.length ? modes.join(' · ') : t('carry.prep', { n: i + 1 }));
    })
    .join(', ');
  const ghost = pinned.includes(hero.carry?.wave ?? 0);
  toastAction(
    t(ghost ? 'carry.pinned.ghost' : 'carry.pinned', { where }),
    t('carry.pinned.take', { item: itemName(item, hero.heroClass) }),
    () =>
      void (async () => {
        for (const i of pinned) {
          const l = loadoutAt(hero, i);
          if (!(await cmd({ t: 'loadout', index: i, loadout: { ...l, gear: { ...l.gear, [slot]: item.id } } }))) break;
        }
        rerender();
      })(),
    9000,
  );
};
